var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    directives: [
      {
        name: "model",
        rawName: "v-model.lazy",
        value: _vm.formValue,
        expression: "formValue",
        modifiers: { lazy: true }
      }
    ],
    class: _vm.textAreaClass,
    attrs: {
      rows: "1",
      name: _vm.formName,
      disabled: _vm.disabled,
      cols: "50"
    },
    domProps: { value: _vm.formValue },
    on: {
      change: function($event) {
        _vm.formValue = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }